<div class="modal-header">
  <h4 class="modal-title mb-2">Confirmation</h4>
  <button type="button" class="close dismiss" aria-label="Close" (click)="Onconfirmation('dismiss')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" style="height:440px">
  <p><strong>Are you sure to continue with the given images?</strong></p>
  <div class="pw" style="margin-top: -66px">
    <main>
      <section class="main">
        <span class="wheelframe" style="--bg-image:url('{{wheelFrameImgPath}}');">
          <ul class="wheel">
          </ul>
          <div class="spin-btn" (click)="rotateWheel()">
            <img src="/bingo_shared_assets/bingo/assets/images/prize_wheel/default_spin.png" alt=""
              srcset="">
            </div>
          </span>
        </section>
        @if (spinBlinkingLights) {
          <div class="lightEffect" [style.backgroundImage]="'url(' +lightanimUrl + ')'">
          </div>
        }
      </main>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="gms-btn secondary" (click)="Onconfirmation('decline')">
      Cancel
    </button>
    <button type="button" class="gms-btn primary" (click)="Onconfirmation('accept')">
      OK
    </button>
  </div>